/**
 * [pug template]
 */
<template lang="pug">
div
  div(id="olst-application")
    virtual-form(:product-ref="recipe.product_ref", :recipe="recipe", :bundle="bundle", :uom="uom", :version="version", :mint="mint", v-on:cc-changed="ccDispatchChanged", :debug="debug", :isMobile="isMobile")
</template>
/**
 * [javascript application]
 */
<script>
import clientConfig from '../../config/global'
import mobile from '../../lib/common/mobile'

export default {
  name: 'olst',
  /** **************************************************************************
   * ***************************************************************************
   * External properties
   */
  props: {
    uom: {
      type: String,
      default: 'cm'
    },
    version: {
      type: String,
      default: 'default'
    },
    debug: {
      type: Boolean,
      default: false
    }
  },
  created: function () {
    this.isMobile = mobile.deviceIsMobile()
  },
  /** **************************************************************************
   * ***************************************************************************
   * Data values
   */
  data () {
    return {
      isMobile: false,
      mint: 0,
      recipe: {},
      bundle: {},
      event: {
        /**
         * Event: Le moteur est monté dans la page
         * @type {null|object}
         */
        mounted: null,
        /**
         * Event: Le formulaire du moteur a été modifié
         * @type {null|object}
         */
        changed: null,
        /**
         * Event: Le moteur a fini de mettre à jour les données
         * @type {null|object}
         */
        updated: null
      }
    }
  },
  /** **************************************************************************
   * ***************************************************************************
   * Components
   */
  components: clientConfig.rendering_blocks,
  /** **************************************************************************
   * ***************************************************************************
   * Quand le composant est chargé
   */
  mounted: function () {
    /**
     * Retourne un Event qui porte le nom passé en parametre
     * @param  {string} eventName
     * @return {object}           Created event
     */
    var initEvent = function (eventName) {
      var event = document.createEvent('Event')
      event.initEvent(eventName, true, true)
      return event
    }
    // Déclare les évenements de l'API externe
    this.event.mounted = initEvent('olst-rendering-mounted')
    this.event.changed = initEvent('olst-rendering-changed')
    this.event.updated = initEvent('olst-rendering-updated')
    // Enregistre le listener 'olst-rendering-update'
    this.registerEventUpdate()
    // Notifie que le moteur est monter
    this.dispatchEventMounted()
    // Notifie que le moteur est disponible
    this.dispatchEventUpdated()
  },
  /** **************************************************************************
   * ***************************************************************************
   * Computed methods
   */
  computed: {
  },
  /** **************************************************************************
   * ***************************************************************************
   * Watch methods
   */
  watch: {
    /**
     * Recipe watcher
     */
    recipe: function () {
      // console.log('Olst.vue - Recipe - changed')
    },
    /**
     * Bundle watcher
     */
    bundle: function () {
      // Le bundle change, on incrémente mint
      if (this.mint < 2) {
        this.mint++
      }
      // console.log('Olst.vue - Bundle - changed')
    }
  },
  /** **************************************************************************
   * ***************************************************************************
   * Methods
   */
  methods: {
    /**
     * Notifie que le moteur est monté dans la page
     */
    dispatchEventMounted: function () {
      this.event.mounted.data = {}
      this.event.mounted.data.event = 'olst-rendering-mounted'
      document.dispatchEvent(this.event.mounted)
    },
    /**
     * Notifie que la cc à changé
     * @param  {object} cc
     */
    ccDispatchChanged: function (cc) {
      // Le formulaire change, on incrémente mint
      this.event.changed.data = {}
      this.event.changed.data.event = 'olst-rendering-changed'
      this.event.changed.data.cc = JSON.stringify(cc)
      document.dispatchEvent(this.event.changed)
    },
    /**
     * Notifie que le moteur a fini de mettre à jour les données
     */
    dispatchEventUpdated: function () {
      this.event.updated.data = {}
      this.event.updated.data.event = 'olst-rendering-updated'
      document.dispatchEvent(this.event.updated)
    },
    /**
     * Réception de la demande de la boutique pour la mise à jour du formulaire
     */
    registerEventUpdate: function () {
      var vue = this
      // Lors de la demande de mise à jour du moteur de rendu
      var onOlstUpdate = function (eventUpdate) {
        var parsedJson = JSON.parse(eventUpdate.data)
        // Si le champ est une Recipe
        if (typeof parsedJson.fields !== 'undefined') {
          // Mise à jour de la Recipe
          vue.recipe = parsedJson
          vue.mint = 0
          // console.log('Recipe mit à jour')
        // Si le champ est un Bundle
        } else if (typeof parsedJson.config_1 !== 'undefined') {
          // Mise à jour du Bundle
          vue.bundle = parsedJson
          // console.log('Bundle mit à jour')
        }
        // Notifie que le moteur est disponible
        vue.dispatchEventUpdated()
      }
      document.addEventListener('olst-rendering-update', onOlstUpdate, false)
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// Olst.vue?24dc4f0c